import React from "react";

// core components
import MainContentsList from "components/Contents/MainContentsList.jsx";

//언어 셋팅
import { withTranslation } from "react-i18next";
import i18n from "config/lang/i18n.js";

const SectionMainContents = (props) => {

  return (
    <>
      {/* Popular Tourist attractions */}
      <MainContentsList {...props} type={"travel"} typeId={"1"} colorType={"default"} title={i18n.t('mainTravelPopular')} />
      {/* Popular Food/Restaurant */}
      <MainContentsList {...props} type={"food"} typeId={"3"} colorType={"default"} title={i18n.t('mainFoodPopular')} />
      {/* Popular Hotel */}
      <MainContentsList {...props} type={"hotel"} colorType={"default"} title={i18n.t('mainHotelPopular')} />
      {/* Popular Shopping */}
      <MainContentsList {...props} type={"shopping"} typeId={"5"} colorType={"default"} title={i18n.t('mainShoppingPopular')} />
    </>
  );
};

export default withTranslation()(SectionMainContents);